import Checkbox from "components/core/Checkbox";
import { Text } from "components/core/Text";

type Props = {
  checked: boolean;
  disabled: boolean;
  onCheckedChange: (checked: boolean) => void;
};

const DontAskAgainCheckbox = ({ checked, disabled, onCheckedChange }: Props) => (
  <Checkbox checked={checked} disabled={disabled} onCheckedChange={onCheckedChange}>
    <Text color="subtle" variant="caption">
      Don&apos;t ask again &middot; <a href="/profile">Re-enable in User Settings</a>
    </Text>
  </Checkbox>
);

export default DontAskAgainCheckbox;
